import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from "typeorm";
import { CommonColumns } from "./common-columns.entity";
import { Company } from "./company.entity";
import { Shop } from "./shop.entity";
import { Exclude } from "class-transformer";

@Entity()
export class Brand extends CommonColumns {

  @Column({ length: 100, })
  name: string;

  @ManyToOne(() => Company, company => company.brands, { nullable: false, })
  @JoinColumn({ name: 'company_id', referencedColumnName: 'id', })
  company: Company;

  @Column({ name: 'company_id', })
  companyId: number;

  @Exclude()
  @Column({ name: 'common_shop_token', })
  commonShopToken: string;

  @OneToMany(() => Shop, shop => shop.brand)
  shops: Shop[];

  constructor(props: IBrand) {
    super();
    Object.assign(this, props);
  }
}

export declare type TBrand = Omit<Brand, 'dummy-no-such-field'>;
export interface IBrand extends TBrand {};
